import { render, staticRenderFns } from "./TransferAccounts.vue?vue&type=template&id=7dfd5df8"
import script from "./TransferAccounts.vue?vue&type=script&lang=js"
export * from "./TransferAccounts.vue?vue&type=script&lang=js"
import style0 from "./TransferAccounts.vue?vue&type=style&index=0&id=7dfd5df8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports